export const SALARY_ARRAY = [
  ["-", null],
  ["3 000", 3000],
  ["5 000", 5000],
  ["8 000", 8000],
  ["10 000", 10000],
  ["15 000", 15000],
]

export const PHONE_STARTS_ARRAY = [
  '+48',
  '+49',
  '+420',
  '+380',
]

export const PHONE_TYPES_ARRAY = [
  ['+48', '### ### ###'],
  ['+49', '#### #######'],
  ['+420', '### ### ###'],
  ['+380', '## ### ####'],
]
